import { Tabs } from "antd";
import DeviceApi from "../../../../../api/DeviceApi";
import { DeviceDetailsWrapper} from "./DeviceDetails.styled";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ViewStateService from "../../../../../services/view-state/ViewStateService";
import DeviceInformation from "./components/device-information/DeviceInformation";
import RealtimeDeviceMetrics from "./components/realtime-device-metrics/RealtimeDeviceMetrics";
import HistoryDeviceMetrics from "./components/history-device-metrics/HistoryDeviceMetrics";

interface DeviceDetailsProps {
   
}

const DeviceDetails: React.FC<DeviceDetailsProps> = (props)=> {
    // api
    let navigate = useNavigate();
    let location = useLocation();
    let viewStateService = ViewStateService.getInstance();
    let deviceApi = new DeviceApi();
    let [loading, setLoading] = useState(true);

    // parameters
    let {deviceId} = useParams();
    let [searchParams] = useSearchParams();
    let defaultTabKey = searchParams.get('tab') || 'device-information';

    // state
    let [deviceView, setDeviceView] = useState(null);

    // events
    let loadDevice = async ()=> {
        setLoading(true);
        if(!deviceId) {
            return;
        }

        let deviceView = (await deviceApi.getDeviceViewByDeviceId(deviceId)).data.data;
        setDeviceView(deviceView);
        setLoading(false);
    }

    let onGoBack = ()=> {
        if(location.key=='default') {
            navigate("/device-management");
        } else {
            navigate(-1);
        }
    }
    
    useEffect(()=> {
        // load device information according to device id parameter
        loadDevice();
    }, []);

     // set status bar title
    useEffect(() => {
        if (deviceView && deviceView.device) {
            viewStateService.setStatusBarTitle(deviceView.device.name);
        }
    }, [deviceView]); 
    
    // render
    let tabItems = [
        {
            key: 'device-information',
            label: '设备信息',
            children: deviceView && <DeviceInformation deviceView={deviceView} />
        },
        {
            key: 'device-metrics-realtime',
            label: '实时数据',
            children: deviceView && <RealtimeDeviceMetrics deviceView={deviceView} />
        },
        {
            key: 'device-metrics-history',
            label: '历史数据',
            children: deviceView && <HistoryDeviceMetrics deviceView={deviceView} />
        },
    ];

    return (
        <DeviceDetailsWrapper>
            {loading ? <div></div> : 
           <div>
            { deviceView && 
                <Tabs
                    defaultActiveKey={defaultTabKey}
                    items={tabItems}
                    style={{flex: '1 1 auto', overflow: 'hidden'}}
                    centered
                />
            }</div>
            }
           
        </DeviceDetailsWrapper>
    )
}

export default DeviceDetails;

